// Shape for useReportHistoryInfinite — react-query infinite query cache shape
export const MOCK_REPORT_HISTORY_INFINITE = {
  pages: [
    {
      results: [
        {
          id: 'mock-report-1',
          name: 'Full Security Report — November 2024',
          default_name: 'Full Security Report — November 2024',
          display_name: 'Full Security Report — November 2024',
          kind: null,
          description: '',
          tags: [],
          is_pinned: false,
          created_by: null,
          status: 'COMPLETED',
          file_type: 'pdf',
          lang: 'en',
          created_at: '2024-11-15T10:00:00Z',
          created_at_jalali: '1403/08/25 10:00',
        },
        {
          id: 'mock-report-2',
          name: 'Executive Summary — Q4 2024',
          default_name: 'Executive Summary — Q4 2024',
          display_name: 'Executive Summary — Q4 2024',
          kind: null,
          description: '',
          tags: [],
          is_pinned: false,
          created_by: null,
          status: 'COMPLETED',
          file_type: 'html',
          lang: 'en',
          created_at: '2024-11-14T15:30:00Z',
          created_at_jalali: '1403/08/24 15:30',
        },
        {
          id: 'mock-report-3',
          name: 'گزارش آسیب‌پذیری‌های بحرانی',
          default_name: 'گزارش آسیب‌پذیری‌های بحرانی',
          display_name: 'گزارش آسیب‌پذیری‌های بحرانی',
          kind: null,
          description: '',
          tags: [],
          is_pinned: false,
          created_by: null,
          status: 'PENDING',
          file_type: 'pdf',
          lang: 'fa',
          created_at: '2024-11-16T08:00:00Z',
          created_at_jalali: '1403/08/26 08:00',
        },
      ],
      current_page: 1,
      total_pages: 1,
    },
  ],
  pageParams: [1],
}

// Shape for useReportTemplates
export const MOCK_REPORT_TEMPLATES = [
  {
    id: 'mock-tpl-1',
    name: 'Executive Summary',
    description: 'High-level overview for management — key metrics and critical findings.',
    type: 'html',
    language: 'en',
    created_at: '2024-10-01T00:00:00Z',
  },
  {
    id: 'mock-tpl-2',
    name: 'Technical Vulnerability Report',
    description: 'Detailed technical report with full CVE details, CVSS scores, and remediation steps.',
    type: 'html',
    language: 'en',
    created_at: '2024-10-15T00:00:00Z',
  },
  {
    id: 'mock-tpl-3',
    name: 'گزارش کامل فارسی',
    description: 'قالب گزارش جامع به زبان فارسی با تمام جزئیات فنی.',
    type: 'html',
    language: 'fa',
    created_at: '2024-11-01T00:00:00Z',
  },
]
